import React from "react";

interface SimulationDetailViewProps {
  isActive: boolean;
  isPaused: boolean;
  progress: number;
  speed: number;
  distance: number;
  totalDistance: number;
  time: number;
  totalTime: number;
  onPause: () => void;
  onStop: () => void;
  onOpenSettings: () => void;
  onClose: () => void;
}

const formatElapsedTime = (seconds: number) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  if (hrs > 0) {
    return `${hrs}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export const SimulationDetailView: React.FC<SimulationDetailViewProps> = ({
  isPaused,
  progress,
  speed,
  distance,
  totalDistance,
  time,
  totalTime,
  onPause,
  onStop,
  onOpenSettings,
  onClose,
}) => {
  return (
    <>
      <div
        className="island-header"
        style={{ marginBottom: "4px", padding: "8px 8px 4px 8px" }}
      >
        <div className="island-header-content">
          <div className="island-icon">📍</div>
          <div className="island-text">
            <div className="island-title">GPS Simulation</div>
            <div className="island-subtitle">
              {isPaused ? "Paused" : `${Math.round(progress * 100)}% complete`}
            </div>
          </div>
        </div>
        <div
          className="island-actions"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <button
            className="island-btn primary"
            onClick={onPause}
            style={{ padding: "4px 8px", fontSize: "10px" }}
          >
            {isPaused ? "Resume" : "Pause"}
          </button>
          <button
            className="island-btn danger"
            onClick={onStop}
            style={{ padding: "4px 8px", fontSize: "10px" }}
          >
            Stop
          </button>
          <button className="island-close" onClick={onClose}>
            ×
          </button>
        </div>
      </div>

      <div className="island-details" style={{ padding: "12px" }}>
        {/* Progress bar */}
        <div className="island-progress" style={{ marginBottom: "12px" }}>
          <div className="island-progress-bar">
            <div
              className="island-progress-fill sim"
              style={{ width: `${progress * 100}%` }}
            />
          </div>
          <span
            className="island-progress-text"
            style={{ fontSize: "10px", marginTop: "4px" }}
          >
            {Math.round(progress * 100)}% complete
          </span>
        </div>

        {/* Stats grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "8px",
            marginTop: "8px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              padding: "4px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "6px",
            }}
          >
            <div
              style={{
                fontSize: "9px",
                color: "var(--text-secondary)",
                marginBottom: "2px",
              }}
            >
              Speed
            </div>
            <div style={{ fontSize: "14px", fontWeight: 600 }}>
              {speed.toFixed(1)}
            </div>
            <div
              style={{
                fontSize: "8px",
                color: "var(--text-secondary)",
              }}
            >
              km/h
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              padding: "4px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "6px",
            }}
          >
            <div
              style={{
                fontSize: "9px",
                color: "var(--text-secondary)",
                marginBottom: "2px",
              }}
            >
              Distance
            </div>
            <div style={{ fontSize: "12px", fontWeight: 600 }}>
              <span>{distance.toFixed(1)}</span>
              <span
                style={{
                  color: "var(--text-secondary)",
                  fontWeight: 400,
                }}
              >
                {" "}
                /{" "}
              </span>
              <span style={{ color: "var(--text-secondary)" }}>
                {totalDistance.toFixed(1)}
              </span>
            </div>
            <div
              style={{
                fontSize: "8px",
                color: "var(--text-secondary)",
              }}
            >
              km
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              padding: "4px",
              background: "rgba(255,255,255,0.05)",
              borderRadius: "6px",
            }}
          >
            <div
              style={{
                fontSize: "9px",
                color: "var(--text-secondary)",
                marginBottom: "2px",
              }}
            >
              Time
            </div>
            <div style={{ fontSize: "12px", fontWeight: 600 }}>
              <span>{formatElapsedTime(time)}</span>
              <span
                style={{
                  color: "var(--text-secondary)",
                  fontWeight: 400,
                }}
              >
                {" "}
                /{" "}
              </span>
              <span style={{ color: "var(--text-secondary)" }}>
                {formatElapsedTime(totalTime)}
              </span>
            </div>
            <div
              style={{
                fontSize: "8px",
                color: "var(--text-secondary)",
              }}
            >
              elapsed
            </div>
          </div>
        </div>

        {/* Settings link */}
        <button
          className="island-btn default"
          onClick={onOpenSettings}
          style={{
            width: "100%",
            marginTop: "12px",
            padding: "6px",
            fontSize: "10px",
          }}
        >
          Simulation Settings
        </button>
      </div>
    </>
  );
};
